// generated on build time, from script >> scripts/build-environment-conf.sh

export const environment = {
  production: true,
  env: 'pro',
  baseUrl: 'https://api.belender.net',
  cdnImgBaseUrl: 'https://widget.belender.net/assets/img/',
  scraperMock: false,
  notificationsBaseUrl: 'wss://notifications.belender.net',
  isWebComponent: false // 👇 Variable para el modo SPA o web-component
};


